module.exports = __webpack_public_path__ + "img/unload-5-3.cabb697f.png";